import './styles/global.css';
import './styles/app.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { ToastProvider } from './components/Toasts';
import { registerServiceWorker } from './lib/pwa';

const root = document.getElementById('root');
if (!root) throw new Error('#root missing');

createRoot(root).render(
  <StrictMode>
    <ToastProvider>
      <App />
    </ToastProvider>
  </StrictMode>,
);

// Warm up the Markdown/KaTeX chunk while the user is still pasting a link.
const prefetch = () => void import('./components/MarkdownView');
if ('requestIdleCallback' in window) window.requestIdleCallback(prefetch, { timeout: 3000 });
else setTimeout(prefetch, 1500);

registerServiceWorker();
